import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../data-structures/results/result-row.model";

export function makeDebtSchedule(param: DebtScheduleInterface = {}) {
  param['RESULTS.DATA.TOTALS'] = param['RESULTS.DATA.TOTALS']
    ? new LoanResult(param['RESULTS.DATA.TOTALS'])
    : new LoanResult();
  for (const key in param) {
    if (key !== 'RESULTS.DATA.TOTALS') {
      param[key] = new LoanResult(param[key])
    }
  }
  return param;
}

export interface DebtScheduleInterface extends Record<string, LoanResult> {
 'RESULTS.DATA.TOTALS'?: LoanResult;
}

interface LoanResultInterface {
  formatValues?: string[];
 'RESULTS.DATA.PRINCIPAL'?: ResultRow;
 'RESULTS.DATA.BALANCE'?: ResultRow;
 'RESULTS.DATA.INTEREST'?: ResultRow;
 'RESULTS.DATA.REPAYMENT'?: ResultRow;
}
export class LoanResult {
  formatValues;
  'RESULTS.DATA.PRINCIPAL';
  'RESULTS.DATA.BALANCE';
  'RESULTS.DATA.INTEREST';
  'RESULTS.DATA.REPAYMENT';
  get principal() {
    return this['RESULTS.DATA.PRINCIPAL'];
  }
  set principal(value: ResultRow) {
    this['RESULTS.DATA.PRINCIPAL'] = value;
  }
  get balance() {
    return this['RESULTS.DATA.BALANCE'];
  }
  set balance(value: ResultRow) {
    this['RESULTS.DATA.BALANCE'] = value;
  }
  get interest() {
    return this['RESULTS.DATA.INTEREST'];
  }
  set interest(value: ResultRow) {
    this['RESULTS.DATA.INTEREST'] = value;
  }
  get repayment() {
    return this['RESULTS.DATA.REPAYMENT'];
  }
  set repayment(value: ResultRow) {
    this['RESULTS.DATA.REPAYMENT'] = value;
  }

  constructor(param: LoanResultInterface = {}) {
    this['RESULTS.DATA.PRINCIPAL'] = param['RESULTS.DATA.PRINCIPAL']
      ? new ResultRow(param['RESULTS.DATA.PRINCIPAL'])
      : new ResultRow();

    this['RESULTS.DATA.BALANCE'] = param['RESULTS.DATA.BALANCE']
      ? new ResultRow(param['RESULTS.DATA.BALANCE'])
      : new ResultRow();

    this['RESULTS.DATA.INTEREST'] = param['RESULTS.DATA.INTEREST']
      ? new ResultRow(param['RESULTS.DATA.INTEREST'])
      : new ResultRow();

    this['RESULTS.DATA.REPAYMENT'] = param['RESULTS.DATA.REPAYMENT']
      ? new ResultRow(param['RESULTS.DATA.REPAYMENT'])
      : new ResultRow();

    if (param.formatValues) {
      this.formatValues = param.formatValues;
    }
  }

  deepCopy() {
    return new LoanResult(cloneDeep(this));
  }
}

/** only the enumerable keys of interest */
export type LoanResultKeys = 'RESULTS.DATA.PRINCIPAL'
  | 'RESULTS.DATA.BALANCE'
  | 'RESULTS.DATA.INTEREST'
  | 'RESULTS.DATA.REPAYMENT';